import { render } from "./NewViewTemplate.vue?vue&type=template&id=14e8c023&scoped=true"
import script from "./NewViewTemplate.vue?vue&type=script&lang=js"
export * from "./NewViewTemplate.vue?vue&type=script&lang=js"

import "./NewViewTemplate.vue?vue&type=style&index=0&id=14e8c023&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e8c023"]])

export default __exports__